import { Component } from '@angular/core';
import { Input } from '@angular/core';
import { Observable } from 'rxjs';
import { LabelsService } from 'src/app/services/labels.service';

@Component({
    selector: 'app-errormessage',
    templateUrl: './errormessage.component.html',
    styleUrls: ['./errormessage.component.scss']
})
export class ErrorMessageComponent {
    @Input()
    public serverErrorMessage: string;
    @Input()
    public errorMessageTranslationKey: string;

    constructor(private labelsService: LabelsService) {
    }

    public translateLabel(translationKey: string, defaultValue: string): Observable<string> {
        return this.labelsService.translateLabel(translationKey, defaultValue);
    }
}
